<template>
    <div class="booking-form-container">
        <!-- Employee Discount Section -->
        <div v-if="checkEmployeeDiscount()" class="employee-discount text-center mb-3">
            <form :action="apply_employee_discount_url">
                <div v-html="courseDetailsFields()"></div>
                <input v-if="remove_discount == 1" type="hidden" name="remove_discount" value="1">

                <div class="row justify-content-center">
                    <div class="col-md-9">
                        <div class="ml-2 text-right">
                            {{ tra.employee_discount }} | <small>{{ tra.institute_currency }} ({{
                                safeDataObj.course?.institute_currency || 'SAR' }})</small>
                            <input
                                :style="'border: 1px solid #e7e7e7; height: 30px !important; border-radius: 5px; padding-right:10px; width: 100%;'"
                                type="number" :max="employee_discount_type == 'percentage' ? 100 : ''"
                                v-model="employee_dsicount" name="employee_dsicount">
                            <small>{{ tra.fixed_discount_value_note }}</small>
                        </div>
                    </div>
                </div>
                <hr class="my-2">
                <div class="ml-4 d-inline-flex align-items-center">
                    <span class="d-inline-flex align-items-center mx-3">
                        {{ tra.percentage }}
                        <input class="mr-2" @change="change_employee_discount_type()" v-model="employee_discount_type"
                            value="percentage" type="radio" name="employee_discount_type"
                            style="height: 15px; width: 15px;">
                    </span>
                    <span class="d-inline-flex align-items-center">
                        {{ tra.fixed_value }}
                        <input class="mr-2" @change="change_employee_discount_type()" v-model="employee_discount_type"
                            value="fixed" type="radio" name="employee_discount_type" style="height: 15px; width: 15px;">
                    </span>
                </div>
                <div type="submit" class="ml-4 d-inline-flex align-items-center">
                    <button class="ml-xl-4 btn rounded-10 bg-secondary-color text-white"> {{ tra.apply_discount }}
                    </button>
                    <button @click="remove_discount = 1" class="ml-xl-4 btn rounded-10 bg-danger text-white"> {{
                        tra.cancel_discount }} </button>
                </div>
            </form>
        </div>

        <!-- Main Accordion Section -->
        <div id="accordion" class="sticky-top pt-4">
            <div class="bg-white py-4 rounded-10">

                <!-- Course Price Info Box -->
                <div class="bg-white rounded-10 position-relative course-price-info-box px-3">
                    <div class="price-info-loader-box">
                        <img class="price-info-loader" src="/storage/circle-loader.gif">
                    </div>

                    <button @click="AllCoursesPopUpVraibalesAdding()" type="button" data-toggle="modal"
                        data-target="#courses-modal" class="btn text-white bg-secondary-color w-100">{{
                            tra.browse_all_courses }}
                    </button>

                    <hr class="my-2">

                    <!-- Costs Header -->
                    <div class="cost-heading d-flex justify-content-between align-items-center">
                        <h5 class="font-weight-bold text-main-color mb-0">{{ tra.costs }}</h5>

                        <div class="discount-badges">
                            <div v-if="formattedSatDiscount > 0" class="offer-icon sat-discount position-absolute">
                                {{ tra.sat_discount_label }} -{{ formattedSatDiscountPercent }}%
                            </div>
                            <div style="margin-left: -8px;" v-if="formattedInstituteDiscount > 0"
                                class="offer-icon institute-discount position-absolute">
                                {{ tra.institute_discount }} -{{ formattedInstituteDiscountPercent }}%
                            </div>
                        </div>
                    </div>
                    <hr class="my-2">
                </div>

                <!-- Total Price Section -->
                <div v-if="app_name != 'langtour'" class="total-price-section">
                    <div class="reservation-heading px-3 d-flex justify-content-between align-items-center">
                        <h6 class="font-weight-bold text-main-color mb-0">{{ tra.total_price }}</h6>
                        <h5 class="text-main-color m-0 total-price-display">
                            <span class="price-value">{{ formattedTotalPrice }}</span>
                            <span class="small text-dark currency-code">{{ formattedCurrencyDisplay }}</span>
                        </h5>
                    </div>
                    <hr class="mx-3 my-2">
                </div>

                <!-- Course Details -->
                <div class="px-3 course-details-section">
                    <div class="course-name-container">
                        <span class="d-block course-name">{{ safeCourseName }}</span>
                    </div>

                    <div class="d-flex course-pricing">
                        <!-- Same price scenario -->
                        <p v-if="isSamePrice" class="text-main-color price-info" dir="ltr">
                            <span class="weight-bold">
                                <span class="price-amount">{{ formattedCoursePrice }}</span>
                                <span class="small text-dark">{{ formattedCurrencyDisplay }}</span>
                            </span>
                        </p>

                        <!-- Discounted price scenario -->
                        <p v-else class="text-main-color price-info" dir="ltr">

                            <span class="weight-bold discounted-price">
                                <span class="price-amount">{{ formattedDiscountedPrice }}</span>
                                <span class="small text-dark">{{ formattedCurrencyDisplay }}</span>
                            </span>
                            <del class="text-danger ml-2">
                                <span class="original-price">{{ formattedCoursePrice }}</span>
                                <span class="small text-dark">{{ formattedCurrencyDisplay }}</span>
                            </del>
                        </p>

                        <span class="mx-2 price-separator">/</span>
                        <span class="h6 text-main-color d-block m-0 weeks-display">({{ weeksOutput(course_weeks)
                            }})</span>
                    </div>
                </div>

                <hr class="mx-3 my-2">

                <!-- Reservation Form -->
                <div class="reservation-body px-3">
                    <form id="course-prices-form" class="course-prices-form" :action="save_request_url" method="get"
                        autocomplete="off">

                        <input type="hidden" name="custom_residence[description]" v-model="custom_residence.description">
                        <input type="hidden" name="custom_residence[price]" v-model="custom_residence.price">

                        <input type="hidden" name="custom_airport[description]" v-model="custom_airport.description">
                        <input type="hidden" name="custom_airport[price]" v-model="custom_airport.price">


                    

                        <!-- Price Notice -->
                        <span v-if="showPriceNotice" class="text-danger">{{ tra.prices_may_vary }}</span>
                        <br>

                        <!-- Start Date -->
                        <label>
                            {{ tra.start_date }}
                            <span v-if="post_errors.start_date" class="h6 text-danger">
                                ( {{ post_errors.start_date[0] }} )
                            </span>
                        </label>

                        <div class="start-date-container">
                            <DatePicker v-model="start_date" :disabledDays="[0, 2, 3, 4, 5, 6]"
                                :disabledDates="disabledVacationDates" :invalid="!start_date"
                                :placeholder="tra.start_date" :showIcon="true" iconDisplay="input"
                                icon="fal fa-calendar" size="small" dateFormat="dd-mm-yy"
                                @date-select="setCurrentTime" />
                            <input type="hidden" name="start_date" :value="formatDate(start_date)">
                        </div>

                        <!-- Course Weeks -->
                        <div class="form-group mt-2">
                            <label>{{ tra.course_weeks_number }}</label>
                            <select name="course_weeks" v-model="course_weeks" class="form-control rounded-10 border"
                                data-live-search="true">
                                <option v-for="week_count in weeks_count" :value="week_count" :key="week_count">
                                    {{ week_count }}
                                </option>
                            </select>
                        </div>

                        <!-- Residence Section -->
                        <div v-if="hasResidences" class="form-group residence-box">
                            <div class="d-flex justify-content-between">
                                <strong>{{ tra.accommodation }}:</strong>
                                <span v-if="hasResidencePrice" class="text-main-color residence-price">
                                    <span class="price-amount">{{ formattedResidencePrice }}</span>
                                    <span class="small text-dark">{{ formattedCurrencyDisplay }}</span>
                                    <span class="h6 text-main-color weeks-info">
                                        ({{ formattedResidenceWeeks }})
                                    </span>
                                </span>
                            </div>

                            <div class="row">
                                <div class="col-xl-6">
                                    <div class="residence-description">
                                        {{ safeResidenceDescription }}
                                        <br>
                                        <strong v-if="hasResidenceAvailability"
                                            class="text-main-color availability-dates">
                                            ( {{ tra.available_only_from }}
                                            {{ formatDate(safeDataObj.residence?.available_date_from) }} {{ tra.to }}
                                            {{ formatDate(safeDataObj.residence?.available_date_end) }} )
                                        </strong>
                                    </div>
                                </div>
                                <div class="col-xl-6 text-left">
                                    <button type="button" data-toggle="modal" data-target="#residences-modal"
                                        class="btn rounded-10 text-white bg-secondary-color mt-2 py-1 w-100">
                                        {{ tra.browse_accommodation_options }}
                                    </button>
                                </div>
                            </div>

                            <span v-if="post_errors.residence_id && !residence_id" class="h6 text-danger">
                                ( {{ post_errors.residence_id[0] }} )
                            </span>
                        </div>

                     

                        <!-- Residence Weeks -->
                        <div v-if="safeDataObj.residence != 0" class="form-group">
                            <label>{{ tra.accommodation_weeks_number }}</label>
                            <select @change="institute_vacation_checker()" name="residence_weeks"
                                v-model="residence_weeks" class="form-control rounded-10 border"
                                data-live-search="true">
                                <option v-for="week_count in weeks_count" :value="week_count" :key="week_count">
                                    {{ week_count }}
                                </option>
                            </select>
                        </div>
                        

                        <!-- Airport Section -->
                        <div v-if="hasAirports" class="form-group">
                            <div class="d-flex justify-content-between">
                                <label>{{ tra.airport_pickup }} <span v-if="custom_airport.description" class="text-main-color">({{ custom_airport.description }})</span></label>
                                <span v-if="hasAirportPrice" class="text-main-color airport-price">
                                    <span class="price-amount">{{ formattedAirportPrice }}</span>
                                    <span class="small text-dark">{{ formattedCurrencyDisplay }}</span>
                                </span>
                            </div>
                            <select v-model="airport_id" class="form-control rounded-10 border" data-live-search="true">
                                <option :value="0">{{ tra.please_select }}</option>
                                <option :value="'no-airport-needed'"> {{ tra.no }}</option>
                                <option v-for="airport in airportsObj" :key="airport.id" :value="airport.id">
                                    {{ airport.name }} - {{ airport.formatedPrice }}
                                </option>
                            </select>
                            <span v-if="post_errors.airport_id && !airport_id" class="h6 text-danger">
                                ( {{ post_errors.airport_id[0] }} )
                            </span>
                        </div>

                        <!-- Custom Airport Section -->
                        <div v-if="hasAirports && auth_check" class="form-group">
                            <button type="button" @click="airport_id = 'custom_airport'" class="btn rounded-10 bg-secondary-color text-white w-100">
                                {{ tra.add_custom_airport }}
                            </button>
                        </div>

                        <!-- Custom Airport Modal -->
                        <div v-if="airport_id == 'custom_airport'" class="p-2 my-4 custom-airport-box"
                            style='border:1px solid #009994 ; border-radius: 5px;'>
                            <div class="form-group">
                                <label>{{ tra.airport_description }}</label>
                                <input v-model="custom_airport.description" type="text" class="form-control"
                                    :placeholder="tra.airport_description">
                            </div>
                            <div class="form-group">
                                <label>{{ tra.airport_price }}</label>
                                <input v-model="custom_airport.price" type="number" class="form-control">
                            </div>

                            <button @click="choosingCustomAirport" type="button"
                                class="btn rounded-10 bg-main-color mb-3 text-white">{{ tra.add }} </button>
                        </div>

                        <!-- Insurance Section -->
                        <div v-if="hasInsurance" class="row">
                            <div class="col-md-12">
                                <label>{{ tra.do_you_need_insurance }}</label>
                                <span v-if="post_errors.insurance && !insurance_checker" class="h6 text-danger">
                                    ( {{ post_errors.insurance[0] }} )
                                </span>
                                <br />
                            </div>
                            <div class="col-md-6">
                                <div class="form-check form-check-inline mr-0 ml-4">
                                    <input v-model="insurance_checker" name="insurance" type="radio"
                                        style="height: 20px; width: 20px;" id="inlineCheckbox1" value="1"
                                        :class="(post_errors.insurance && !insurance_checker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" />
                                    <label class="form-check-label">
                                        {{ tra.yes }} ({{ formattedInsurancePrice }}<span class="small text-dark">{{
                                            formattedCurrencyDisplay }}</span>)
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-check form-check-inline mr-0 ml-4">
                                    <input v-model="insurance_checker" name="insurance" type="radio"
                                        style="height: 20px; width: 20px;" id="inlineCheckbox2" value="0"
                                        :class="(post_errors.insurance && !insurance_checker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" />
                                    <label class="form-check-label">{{ tra.no }}</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <hr class="my-2">
                            </div>
                        </div>

                        <!-- Visa Section -->
                        <div v-if="hasVisa" class="row">
                            <div class="col-md-12">
                                <label>{{ tra.do_you_need_visa_name }} {{ safeVisaName }}</label>
                                <span v-if="post_errors.visa_checker && !visa_checker" class="h6 text-danger">
                                    ( {{ post_errors.visa_checker[0] }} )
                                </span>
                                <br />
                            </div>

                            <div class="col-md-6">
                                <div class="form-check form-check-inline mr-0 ml-4">
                                    <input v-model="visa_checker" name="visa_checker" type="radio"
                                        style="height: 20px; width: 20px;" id="visaYes" value="1"
                                        :class="(post_errors.visa_checker && !visa_checker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" />
                                    <label class="form-check-label">
                                        {{ tra.yes }}
                                        <span class="text-main-color">({{ formattedVisaPrice }}<span
                                                class="small text-dark">{{ formattedCurrencyDisplay }}</span>)</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-check form-check-inline mr-0 ml-4">
                                    <input v-model="visa_checker" name="visa_checker" type="radio"
                                        style="height: 20px; width: 20px;" id="visaNo" value="0"
                                        :class="(post_errors.visa_checker && !visa_checker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" />
                                    <label class="form-check-label">{{ tra.no }}</label>
                                </div>
                            </div>
                            <div v-if="is_admin == '1'" class="col-md-3">
                                <div class="form-check form-check-inline mr-0 ml-4">
                                    <input v-model="visa_checker" name="visa_checker" type="radio"
                                        style="height: 20px; width: 20px;" id="visaFree" value="free"
                                        :class="(post_errors.visa_checker && !visa_checker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" />
                                    <label class="form-check-label">{{ tra.free }}</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <hr class="my-2">
                            </div>
                        </div>

                        <!-- Additional Costs Section -->
                        <div class="cost-body px-3">
                            <h5 class="font-weight-bold text-main-color mb-3">{{ tra.additional_costs }}</h5>

                            <!-- Textbook Fees -->
                            <div v-if="hasTextbookFees">
                                <span class="d-block fee-item">
                                    <span class="font-weight-bold"> {{ tra.textbook_fees }} : </span>
                                    <span class="text-main-color">
                                        {{ formattedTextbookFees }}<span class="small text-dark">{{
                                            formattedCurrencyDisplay }}</span>
                                    </span>
                                </span>
                                <hr />
                            </div>

                            <!-- Additional Fees -->
                            <div v-if="hasAdditionalFees">
                                <div v-for="fees in safeAdditionalFees" :key="fees.name" class="additional-fee-item">
                                    <span class="d-block fee-item">
                                        <span class="font-weight-bold"> {{ fees.name || '' }} : </span>
                                        <span class="text-main-color">
                                            {{ fees.fees || 0 }}<span class="small text-dark">{{
                                                formattedCurrencyDisplay }}</span>
                                        </span>
                                    </span>
                                    <span v-if="(fees.weeks || 0) > 0" class="h6 text-main-color">
                                        ({{ weeksOutput(fees.weeks) }})
                                    </span>
                                    <hr />
                                </div>
                            </div>

                            <!-- Coupon Discount -->
                            <div v-if="hasCouponDiscount">
                                <span class="d-block fee-item">
                                    <span class="font-weight-bold"> {{ tra.discount_coupon_value }} : </span>
                                    <span class="text-danger">
                                        {{ formattedCouponDiscount }}
                                        <span class="small text-dark">{{ formattedCurrencyDisplay }}</span>
                                    </span>
                                </span>
                                <hr class="my-2">
                            </div>

                            <!-- Coupon Section -->
                            <div v-if="showCouponSection" class="row">
                                <div class="col-md-12"><label>{{ tra.do_you_have_discount_coupon }}</label></div>
                                <div class="col-md-6">
                                    <div class="form-check form-check-inline mr-0 ml-4">
                                        <input v-model="have_coupon" name="have_coupon" type="radio"
                                            style="height: 20px; width: 20px;" value="1"
                                            :class="'form-check-input mr-0 ml-3 bg-secondary'" />
                                        <label class="form-check-label">{{ tra.yes }}</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-check form-check-inline mr-0 ml-4">
                                        <input @change="remove_coupon" v-model="have_coupon" name="have_coupon"
                                            type="radio" style="height: 20px; width: 20px;" value="0"
                                            :class="'form-check-input mr-0 ml-3 bg-secondary'" />
                                        <label class="form-check-label">{{ tra.no }}</label>
                                    </div>
                                </div>
                            </div>

                            <!-- Coupon Input -->
                            <div v-if="have_coupon == '1'" class="coupon-input-section">
                                <hr class="my-2">
                                <div class="row">
                                    <div class="col-9">
                                        <div class="form-group">
                                            <input v-model="coupon_code" name="coupon_code" type="text"
                                                :class="'form-control bg-transparent'"
                                                :placeholder="tra.enter_discount_code">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <button v-if="!coupon_status" @click="apply_coupon" type="button"
                                            class="btn rounded-10 text-white bg-secondary-color">{{ tra.apply
                                            }}</button>

                                        <button v-if="coupon_status" @click="remove_coupon" type="button"
                                            class="btn rounded-10 text-white bg-danger">{{ tra.delete }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- LangTour Total Price -->
                        <div v-if="app_name == 'langtour'" class="langtour-total-section">
                            <div class="reservation-heading px-3 d-flex justify-content-between align-items-center">
                                <h6 class="font-weight-bold text-main-color mb-0">{{ tra.total_price }}</h6>
                                <h5 class="text-main-color m-0 total-price-display">
                                    <span class="price-value">{{ formattedTotalPrice }}</span>
                                    <span class="small text-dark">{{ formattedLangTourCurrency }}</span>
                                </h5>
                            </div>
                            <hr class="mx-3 my-2">
                        </div>

                        <!-- Students Number (Admin only) -->
                        <div v-if="is_admin == '1'" class="form-group">
                            <label>{{ tra.students_number }}</label>
                            <input type="number" name="students_number" v-model="students_number"
                                class="form-control rounded-10 border">
                        </div>

                        <!-- Action Buttons -->
                        <div v-if="safeDataObj.course?.price_orgi" class="action-buttons-section">
                            <button v-if="app_name == 'sat-edu'"
                                class="btn rounded-10 bg-secondary-color text-white mb-2 w-100">{{ tra.book }}</button>
                            <button @click="compare_offer = true"
                                class="btn rounded-10 bg-main-color text-white mb-2 w-100">{{ tra.compare_price_offer
                                }}</button>
                            <button @click="invoice" class="w-100 btn rounded-10 bg-secondary-color text-white mb-2">{{
                                tra.get_price_quote }}</button>

                            <button v-if="isTamaraEnabled" @click="pay_with_tamara" type="button"
                                class="w-100 btn rounded-10 tamara-pay-btn text-white mb-2 d-flex align-items-center justify-content-center">
                                <img src="https://schools.1nextlevel.co/storage/tamara-logo.png" alt="Tamara" class="tamara-btn-logo"
                                    v-if="tamaraLogoExists">
                                <span>{{ tra.pay_with_tamara }}</span>
                            </button>

                            <hr>
                            <p class="whatsapp-notice">
                                {{ tra.send_price_via_whatsapp }}
                                <button class="rounded-10 bg-main-color text-white p-1"
                                    @click="invoice({ WASendOffer: true })">{{ tra.click_here }}</button>
                            </p>

                            <hr v-if="is_admin == '1' && app_name == 'sat-edu'">

                            <!-- Admin Buttons -->
                            <div v-if="is_admin == '1' && app_name == 'sat-edu'" class="row admin-buttons">
                                <div class="col-md-6">
                                    <button v-if="is_admin == '1'" @click="invoice"
                                        class="w-100 btn rounded-10 bg-secondary-color text-white mb-2">{{
                                        tra.price_quote }}</button>
                                </div>
                                <div class="col-md-6">
                                    <button v-if="is_admin == '1'" type="button" data-toggle="modal"
                                        data-target="#save-offer-file"
                                        class="w-100 btn rounded-10 text-white bg-secondary-color mb-2">{{
                                        tra.save_price_quote }}</button>
                                </div>

                                <div class="col-12">
                                    <button v-if="add_new_student_request_obj" @click="save_new_student_offer"
                                        class="w-100 btn rounded-10 bg-main-color text-white mb-2">
                                        {{ tra.save_request_for }} ({{ safeStudentName }})
                                    </button>
                                </div>
                            </div>

                            <button type="button" v-if="is_admin == '1' && request_id" @click="sub_form_with_request_id"
                                class="btn rounded-10 bg-secondary-color text-white mb-2 w-100">{{ tra.save_request_data
                                }}</button>
                        </div>
                        <div v-else>
                            <strong class="text-danger"> الدورة غير متاحة تحت عدد الاسابيع المختارة, يرجى تغيير عدد الاسبيع
                            </strong>
                        </div>

                        <!-- Hidden Form Fields -->
                        <input type="hidden" name="_token" :value="csrf_token">
                        <input type="hidden" name="institute_id" :value="institute_id">
                        <input type="hidden" name="course_id" :value="course_id">
                        <input v-if="hasResidences" type="hidden" name="residence_id"
                            :value="residence_id != 0 ? residence_id : ''">
                        <input v-if="hasAirports" type="hidden" name="airport_id"
                            :value="airport_id != 0 ? airport_id : ''">
                        <input type="hidden" name="insurance_price" :value="safeDataObj.insurance">
                        <input type="hidden" name="insurance_price_value" :value="safeDataObj.insurance_price">
                        <input v-if="safeDataObj.visa != 0" type="hidden" name="visa_checker" :value="visa_checker">
                        <input type="hidden" name="insurance_checker" :value="insurance_checker">
                        <input type="hidden" name="coupon_code" :value="coupon_code">
                        <input class="invoice_checker" type="hidden" name="" value="0">
                        <input class="WASendOffer" type="hidden" name="" value="0">
                        <input class="save_new_student_offer" type="hidden" name="" value="0">
                        <input class="tamara_checkout_flag" type="hidden" name="" value="0">
                        <input class="tamara_name_field" type="hidden" name="" value="">
                        <input class="tamara_email_field" type="hidden" name="" value="">
                        <input class="tamara_phone_field" type="hidden" name="" value="">
                        <input class="tamara_dial_code_field" type="hidden" name="" value="">
                        <input v-if="is_admin == '1' && request_id" type="hidden" name="request_id" value="">
                        <input v-if="compare_offer" type="hidden" name="compare_offer" value="1">
                        <input type="hidden" name="currency_code" :value="safeDataObj.currency?.code || 'SAR'">
                    </form>
                </div>
            </div>

            <button @click="goToRelatedCourse()" id="related-courses"
                class="d-lg-none d-block btn rounded-10 bg-main-color text-white mb-2 w-100 mt-5">
                {{ tra.available_courses_options }}
            </button>
        </div>



        <div class="modal fade" id="residences-modal" tabindex="-1" aria-labelledby="successModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <button type="button" class="close modal-close-btn-absolute" data-dismiss="modal">&times;</button>
                    <div class="modal-body py-5 px-4 text-right">
                        <div class="form-group mt-2">
                            <label>{{ tra.accommodation_age_question }}</label>
                            <select @change="residence_id = 0" v-model="selectResidenceAge"
                                class="form-control rounded-10 border select-residence-age py-0">
                                <option value="">{{ tra.please_select }}</option>
                                <option value="under_16">{{ tra.under_16_age }}</option>
                                <option value="16">{{ tra.age_16_option }}</option>
                                <option value="17">{{ tra.age_17_option }}</option>
                                <option value="18">{{ tra.over_18 }}</option>
                            </select>
                        </div>
                        <hr>
                        <h5>
                            <input style="height: 20px; width: 20px;" type="radio" v-model="residence_id"
                                value="no-residence-needed">
                            {{ tra.no_need_accommodation }}
                        </h5>
                        <hr class="my-2">
                        <div v-for="residence in sortedResidences" :key="residence.id">
                            <div class="text-dark d-flex mb-4">
                                <input @change="ResidencesChangeHandeler"
                                    style="height: 20px; width: 20px;margin-top: 5px;" type="radio"
                                    v-model="residence_id" :value="residence.id">
                                <div class="mr-3">
                                    {{ residence.description || '' }}
                                    <div>
                                        <div v-if="residence.price.residence_discount_obj.total_discounts"
                                            class="d-flex align-items-end">
                                            <del class="text-danger">{{ residence.price.residence_price_formated
                                                }}</del>
                                            <p class="text-main-color mt-1 d-block">
                                                <strong>{{ residence.price.residence_discounted_price_formated
                                                    }}</strong> / {{ weeksOutput(1) }}
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p class="text-main-color mt-1 d-block">
                                                <strong>{{ residence.price.residence_price_formated }}</strong> / {{
                                                weeksOutput(1) }}
                                            </p>
                                        </div>
                                    </div>
                                    <strong
                                        v-if="residence.available_date_end != null && residence.available_date_from != null"
                                        class="text-danger mt-1 d-block"> ( {{ tra.available_only_from }}
                                        {{ formatDate(residence.available_date_from) }} {{ tra.to }}
                                        {{ formatDate(residence.available_date_end) }} ) </strong>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="course-include d-inline-block mb-2 col-6">
                                    <div class="include-img d-inline-block"><i
                                            class="fas fa-home text-main-color fa-lg position-relative"></i></div>
                                    <div class="include-info d-inline-block pr-2">
                                        <p class="mb-1">{{ tra.residence_age }}</p>
                                        <p class="text-main-color font-weight-bold mb-2">
                                            {{ ageRangeDisplay(residence) }}</p>
                                    </div>
                                </div>
                                <div class="course-include d-inline-block mb-2 col-6">
                                    <div class="include-img d-inline-block"><i
                                            class="fas fa-home text-main-color fa-lg position-relative"></i></div>
                                    <div class="include-info d-inline-block pr-2">
                                        <p class="mb-1">{{ tra.accommodation_type }}</p>
                                        <p class="text-main-color font-weight-bold mb-2">{{
                                            tra[residence.residence_type] }}</p>
                                    </div>
                                </div>
                                <div class="course-include d-inline-block mb-2 col-6">
                                    <div class="include-img d-inline-block"><i
                                            class="fas fa-bed text-main-color fa-lg position-relative"></i></div>
                                    <div class="include-info d-inline-block pr-2">
                                        <p class="mb-1">{{ tra.room_type }}</p>
                                        <p class="text-main-color font-weight-bold mb-2">{{ residence.room_type || '' }}
                                        </p>
                                    </div>
                                </div>
                                <div class="course-include d-inline-block mb-2 col-6">
                                    <div class="include-img d-inline-block"><i
                                            class="fas fa-bath text-main-color fa-lg position-relative"></i></div>
                                    <div class="include-info d-inline-block pr-2">
                                        <p class="mb-1">{{ tra.bathroom_type }}</p>
                                        <p class="text-main-color font-weight-bold mb-2">{{ residence.bath_type || '' }}
                                        </p>
                                    </div>
                                </div>
                                <div class="course-include d-inline-block mb-2 col-6">
                                    <div class="include-img d-inline-block"><i
                                            class="fas fa-utensils text-main-color fa-lg position-relative"></i></div>
                                    <div class="include-info d-inline-block pr-2">
                                        <p class="mb-1">{{ tra.meals }}</p>
                                        <p v-if="residence.breakfast != null || residence.lunch != null || residence.dinner != null"
                                            class="text-main-color font-weight-bold mb-2">
                                            {{ residence.breakfast == 1 ? tra.breakfast : '' }}
                                            {{ residence.lunch == 1 ? ", " + tra.lunch : '' }}
                                            {{ residence.dinner == 1 ? ", " + tra.dinner : '' }}
                                        </p>
                                        <p v-else class="text-danger font-weight-bold">{{ tra.not_available }}</p>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-2">
                        </div>

                        <div v-if="residence_id == 'custom_residence'" class="p-2 my-4 custom-residence-box"
                            style='border:1px solid #009994 ; border-radius: 5px;'>
                            <div class="form-group">
                                <label>{{ tra.accommodation_description }}</label>
                                <input v-model="custom_residence.description" type="text" class="form-control"
                                    :placeholder="tra.accommodation_description">
                            </div>
                            <div class="form-group">
                                <label>{{ tra.price_per_week }}</label>
                                <input v-model="custom_residence.price" type="number" class="form-control">
                            </div>

                            <button @click="choosingCustomResidence" type="submit"
                                class="btn rounded-10 bg-main-color mb-3 text-white">{{ tra.add }} </button>
                        </div>

                        <button v-if="auth_check" @click="residence_id = 'custom_residence'" type="submit"
                            class="btn rounded-10 bg-secondary-color w-100 text-center mb-3 text-white">{{
                                tra.add_custom_accommodation }}
                        </button>

                    </div>
                </div>
            </div>
        </div>

        <div v-if="vacationModal" class="modal fade" id="institute_vacation_checker_modal" tabindex="-1"
            aria-labelledby="successModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content  p-4">
                    <button type="button" class="close modal-close-btn-absolute" data-dismiss="modal">&times;</button>
                    <div class="modal-bodytext-right">
                        {{ tra.institute_vacation_notice }} {{ vacation.name || '' }} {{ tra.for_duration }} {{
                            (vacation.vacation_weeks || 0)
                                == 1
                                ? tra.one_week : ((vacation.vacation_weeks || 0) == 2 ? tra.two_weeks : (vacation.vacation_weeks
                                    || 0) + ' ' + tra.multiple_weeks)
                        }}،
                        {{ tra.classes_resume }}
                    </div>

                    <hr class="my-2">
                    <span class="text-danger">{{ tra.vacation_period_from }} {{ vacation.vacation_from_date || '' }} {{
                        tra.to }} {{
                            vacation.vacation_to_date || '' }}
                    </span>

                    <div v-if="residence_id != ''">
                        <h4>{{ tra.extend_accommodation_stay }} {{ (vacation.weeks || 0) == 1 ? tra.one_week_option :
                            ((vacation.weeks || 0) ==
                                2 ?
                                tra.two_weeks_option : (vacation.weeks || 0) + ' ' + tra.multiple_weeks_option) }}؟</h4>
                        <div class="row">
                            <div class="col-md-4 col-6">
                                <button @click="hide_vacation_modal" type="button"
                                    class="btn w-100 text-center rounded-10 text-white bg-main-color">{{ tra.no
                                    }}</button>
                            </div>
                            <div class="col-md-4 d-md-block d-none">

                            </div>
                            <div class="col-md-4 col-6">
                                <button @click="add_vacation_weeks" type="button"
                                    class="btn w-100 text-center rounded-10 text-white bg-secondary-color">{{ tra.yes
                                    }}</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="modal fade" id="save-offer-file" tabindex="-1" role="dialog" aria-labelledby="save-offer-fileLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content p-4">
                    <form method="POST" :action="save_student_offer_url" class="my-4">
                        <input type="hidden" name="_token" :value="csrf_token">
                        <div v-html="courseDetailsFields()"></div>
                        <div class="form-group">
                            <input name="name" value="" type="text" :placeholder="tra.full_name"
                                class="form-control rounded-10 border px-3 btn-light">
                            <small v-if="post_errors.name" class="text-danger"> ( {{ post_errors.name[0] }} )</small>
                        </div>
                        <div class="form-group">
                            <input name="email" value="" type="email" :placeholder="tra.email_address"
                                class="form-control rounded-10 border px-3 btn-light">
                            <small v-if="post_errors.email" class="text-danger"> ( {{ post_errors.email[0] }} )</small>
                        </div>
                        <button type="submit"
                            class="btn rounded-10 bg-secondary-color w-100 text-center mb-3 text-white">{{ tra.save }}
                        </button>
                    </form>

                </div>
            </div>
        </div>

        <!-- Modals would go here - keeping them as they are for now -->
        <!-- ... All your existing modals ... -->

        <!-- Tamara Customer Details Modal (Next Level tenant only) -->
        <div v-if="isTamaraEnabled" class="modal fade" id="tamara-customer-modal" tabindex="-1"
            aria-labelledby="tamaraCustomerModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content p-4">
                    <button type="button" class="close modal-close-btn-absolute" data-dismiss="modal">&times;</button>
                    <div class="modal-body text-right">
                        <div class="d-flex align-items-center mb-3">
                            <img src="/storage/tamara-logo.png" alt="Tamara" class="tamara-modal-logo ml-2"
                                v-if="tamaraLogoExists">
                            <h5 class="mb-0 text-main-color">{{ tra.tamara_customer_details }}</h5>
                        </div>
                        <p class="text-muted small">{{ tra.tamara_enter_details_to_continue }}</p>

                        <div class="form-group">
                            <label>{{ tra.full_name }}</label>
                            <input v-model="tamara_customer.name" type="text" class="form-control rounded-10 border"
                                :placeholder="tra.full_name">
                            <small v-if="tamara_errors.name" class="text-danger">( {{ tamara_errors.name }} )</small>
                        </div>

                        <div class="form-group">
                            <label>{{ tra.email_address }}</label>
                            <input v-model="tamara_customer.email" type="email"
                                class="form-control rounded-10 border" :placeholder="tra.email_address">
                            <small v-if="tamara_errors.email" class="text-danger">( {{ tamara_errors.email }}
                                )</small>
                        </div>

                        <div class="form-group">
                            <label>{{ tra.phone_number }}</label>
                            <input id="tamara-phone" v-model="tamara_customer.phone" type="tel"
                                class="text-right form-control rounded-10 border"
                                placeholder="05XXXXXXXX">
                            <small v-if="tamara_errors.phone" class="text-danger">( {{ tamara_errors.phone }}
                                )</small>
                        </div>

                        <div class="text-left mt-3">
                            <button @click="proceed_to_tamara" type="button"
                                class="btn rounded-10 tamara-pay-btn text-white px-4">
                                {{ tra.continue_to_payment }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'primevue/datepicker';

export default {
    name: 'BookingForm',
    components: {
        DatePicker,
    },
    props: [
        "course_price_info_url",
        "csrf_token",
        'institute_courses_count',
        'post_errors',
        'is_admin',
        'auth_check',
        "old",
        "save_request_url",
        "course_id",
        "institute_id",
        "institute_vacation_checker_url",
        "check_coupon_url",
        "apply_employee_discount_url",
        "get_employee_discount_url",
        "employee_discount",
        "save_student_offer_url",
        "add_new_student_request",
        "pref_currency",
        "auth_student",
        "tra"
    ],
    data() {
        return {
            data_obj: {
                course: {
                    discount_obj: {
                        discounts: {},
                        coupon: {}
                    }
                },
                residence: {},
                airport: {},
                visa: {},
                airports: [],
                residences: [],
                currency: { code: 'SAR' },
                total_price: 0,
                insurance: 0,
                insurance_price: 0,
            },
            residence_id: '',
            custom_residence: {
                description: this.old?.custom_residence?.description ?? '',
                price: this.old?.custom_residence?.price ?? '',
            },
            airport_id: '',
            custom_airport: {
                description: this.old?.custom_airport?.description ?? '',
                price: this.old?.custom_airport?.price ?? '',
            },
            insurance_checker: '',
            course_weeks: 1,
            residence_weeks: 1,
            weeks_count: 52,
            start_date: new Date(new Date().setDate(new Date().getDate() + 7 + (1 + 7 - new Date().getDay()) % 7)),
            visa_checker: window.APP_NAME == 'sat-edu' ? '' : '0',
            vacation: '',
            have_coupon: '',
            coupon_code: '',
            coupon_status: '',
            employee_discount_type: '',
            employee_dsicount: 0,
            remove_discount: 0,
            request_id: '',
            request_id_field: 0,
            students_number: 1,
            compare_offer: false,
            add_new_student_request_obj: this.add_new_student_request ? JSON.parse(this.add_new_student_request) : false,
            selectResidenceAge: '',
            vacationModal: true,
            firstTimeChangeResWeeks: true,
            currency_code: 'SAR',
            app_name: window.APP_NAME,
            base_url: window.base_url,
            user_details: {},
            institute_vacations: [],
            disabledVacationDates: [],
            residencesObj: [],
            airportsObj: {},
            lang: window.current_locale,
            isLoading: false,
            tamara_customer: {
                name: '',
                email: '',
                phone: '',
                dial_code: '966',
                country_iso: 'sa',
            },
            tamara_iti: null,
            tamara_errors: {
                name: '',
                email: '',
                phone: '',
            },
            tamaraLogoExists: true,
        };
    },
    computed: {
        // Safe data access with fallbacks
        safeDataObj() {
            return this.data_obj || {};
        },

        // Price related computed properties
        formattedTotalPrice() {
            return this.safeDataObj.total_price || 0;
        },

        formattedCurrencyDisplay() {
            const currencyCode = this.safeDataObj.currency?.code || 'SAR';
            return currencyCode === 'SAR' ? ' ' : currencyCode;
        },

        formattedLangTourCurrency() {
            const currencyCode = this.safeDataObj.currency?.code || 'SAR';
            return currencyCode === 'SAR' ? 'ر.س' : currencyCode;
        },

        // Course related computed properties
        safeCourseName() {
            return this.safeDataObj.course?.name || '';
        },

        formattedCoursePrice() {
            return this.safeDataObj.course?.price || 0;
        },

        formattedDiscountedPrice() {
            return this.safeDataObj.course?.discounted_price || 0;
        },

        isSamePrice() {
            const originalPrice = this.safeDataObj.course?.discounted_price || 0;
            const currentPrice = this.safeDataObj.course?.price || 0;
            return originalPrice === currentPrice;
        },

        // Discount related computed properties
        formattedSatDiscount() {
            return this.safeDataObj.course?.sat_discount || 0;
        },

        formattedSatDiscountPercent() {
            return (this.formattedSatDiscount * 100).toFixed(0);
        },

        formattedInstituteDiscount() {
            return this.safeDataObj.course?.discount_obj?.total_discounts || 0;
        },

        formattedInstituteDiscountPercent() {
            return this.formatNumber((this.formattedInstituteDiscount * 100));
        },

        // Residence related computed properties
        hasResidences() {
            return this.residencesObj && Array.isArray(this.residencesObj) && this.residencesObj.length > 0;
        },

        hasResidencePrice() {
            return this.safeDataObj.residence && this.safeDataObj.residence.price;
        },

        formattedResidencePrice() {
            return this.safeDataObj.residence?.price || 0;
        },

        safeResidenceDescription() {
            return this.safeDataObj.residence?.description || '';
        },

        hasResidenceAvailability() {
            return this.safeDataObj.residence?.available_date_end != null &&
                this.safeDataObj.residence?.available_date_from != null;
        },

        formattedResidenceWeeks() {
            return this.residence_weeks + (this.residence_weeks == 1 ?
                ' ' + (this.tra.weeks_singular || 'اسبوع') + ' ' :
                ' ' + (this.tra.weeks || 'اسابيع') + ' ');
        },

        // Airport related computed properties
        hasAirports() {
            return this.airportsObj && Array.isArray(this.airportsObj) && this.airportsObj.length > 0;
        },

        hasAirportPrice() {
            return this.safeDataObj.airport && this.safeDataObj.airport.price;
        },

        formattedAirportPrice() {
            return this.safeDataObj.airport?.price || 0;
        },

        // Insurance related computed properties
        hasInsurance() {
            return this.safeDataObj.insurance_price != 0;
        },

        formattedInsurancePrice() {
            return this.safeDataObj.insurance || 0;
        },

        // Visa related computed properties
        hasVisa() {
            return this.safeDataObj.visa != 0 && this.app_name == 'sat-edu';
        },

        safeVisaName() {
            return this.safeDataObj.visa?.name || this.tra.visa || 'فيزا';
        },

        formattedVisaPrice() {
            return this.safeDataObj.visa?.price || 0;
        },

        // Additional fees computed properties
        hasTextbookFees() {
            return (this.safeDataObj.course?.textbooks_fees_value || 0) != 0;
        },

        formattedTextbookFees() {
            return this.safeDataObj.course?.textbooks_fees || 0;
        },

        hasAdditionalFees() {
            return this.safeDataObj.additional_fees_data &&
                this.safeDataObj.additional_fees_data.fees_list;
        },

        safeAdditionalFees() {
            return this.safeDataObj.additional_fees_data?.fees_list || [];
        },

        hasCouponDiscount() {
            return this.safeDataObj.course?.discount_obj?.coupon_discount_amount;
        },

        formattedCouponDiscount() {
            return this.safeDataObj.course?.discount_obj?.coupon_discount_amount || 0;
        },

        // UI state computed properties
        showPriceNotice() {
            return (Date.parse(this.start_date) + this.course_weeks * 7 * 24 * 60 * 60 * 1000) > Date.parse('01/01/2025');
        },

        isTamaraEnabled() {
            return this.app_name == 'nextlevel';
        },

        showCouponSection() {
            return this.safeDataObj.visa != 0 && this.app_name == 'sat-edu';
        },

        safeStudentName() {
            return this.add_new_student_request_obj?.['student_name'] || '';
        },


        sortedResidences() {
            if (!this.safeDataObj || !this.residencesObj || !Array.isArray(this.residencesObj)) {
                return [];
            }

            let filteredResidences = [...this.residencesObj]; // Create copy to avoid mutations

            if (this.residencesObj.length > 0) {
                const selectedResidence = this.residencesObj.find(residence => residence.id == this.residence_id);
                if (selectedResidence) {
                    const minAge = selectedResidence.min_age;
                    if (minAge < 16) {
                        this.selectResidenceAge = 'under_16';
                    } else {
                        this.selectResidenceAge = minAge;
                    }
                }
            }

            if (filteredResidences.length > 0) {
                if (this.selectResidenceAge == 'under_16') {
                    filteredResidences = filteredResidences.filter(residence => residence.min_age < 16);
                }
                if (this.selectResidenceAge == 16) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age == 16 ||
                        (residence.min_age < 16 && (residence.max_age == null || residence.max_age >= 16))
                    );
                }
                if (this.selectResidenceAge == 17) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age == 17 ||
                        (residence.min_age < 17 && (residence.max_age == null || residence.max_age >= 17))
                    );
                }
                if (this.selectResidenceAge == 18) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age >= 18 || (residence.max_age == null || residence.max_age >= 18)
                    );
                }
                if (this.selectResidenceAge == '') {
                    filteredResidences = filteredResidences.filter(residence => false);
                }
            }

            const sortingOrder = [
                'family_accommodation',
                'student_housing',
                'private_studio'
            ];

            if (filteredResidences.length > 0) {
                return filteredResidences.sort((a, b) => {
                    const indexA = sortingOrder.indexOf(a.residence_type);
                    const indexB = sortingOrder.indexOf(b.residence_type);
                    return indexA - indexB;
                });
            } else {
                return filteredResidences;
            }
        }
    },
    methods: {

        formatDate(date) {
            if (!date) return '';
            if (typeof date === 'string') return date;
            if (date instanceof Date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
            return '';
        },

        showAlert(message, icon = 'error') {
            const SwalRef = window.Swal || window.Sweetalert2;
            if (SwalRef && typeof SwalRef.fire === 'function') {
                SwalRef.fire({ title: message, text: '', icon: icon });
            } else if (typeof window.sweet_alert_msg === 'function') {
                try {
                    window.sweet_alert_msg(message, icon);
                } catch (e) {
                    alert(message);
                }
            } else {
                alert(message);
            }
        },

        formatNumber(number) {
            if (typeof number !== 'number') return number;

            if ((number - number.toFixed(1)).toFixed(2) == 0) {
                return number.toFixed();
            } else {
                return number.toFixed(1);
            }
        },

        weeksOutput(weeks) {
            const numWeeks = Number(weeks) || 1;
            let msg = '';

            if (numWeeks === 1) {
                msg = this.tra.weeks_singular || 'اسبوع';
            }
            else if (numWeeks === 2) {
                msg = this.tra.two_weeks_option || 'اسبوعان';
            }
            else if (numWeeks > 2 && numWeeks < 11) {
                msg = numWeeks + ' ' + (this.tra.weeks || 'اسابيع');
            }
            else {
                msg = numWeeks + ' ' + (this.tra.weeks_singular || 'اسبوع');
            }

            return msg;
        },

        courseDetailsFields() {
            return `
                <input type="hidden" name="institute_id" value="${this.institute_id}">
                <input type="hidden" name="course_id" value="${this.course_id}">
                <input type="hidden" name="course_slug" value="${this.safeDataObj.course?.course_slug || ''}">
                <input type="hidden" name="institute_slug" value="${this.safeDataObj.course?.institute_slug || ''}">
                <input type="hidden" name="course_weeks" value="${this.course_weeks}">
                <input type="hidden" name="start_date" value="${this.formatDate(this.start_date)}">
                <input type="hidden" name="insurance" value="${this.insurance_checker}">
                <input type="hidden" name="insurance_checker" value="${this.insurance_checker}">
                <input type="hidden" name="insurance_price" value="${this.safeDataObj.insurance}">
                <input type="hidden" name="insurance_price_value" value="${this.safeDataObj.insurance_price}">
                <input type="hidden" name="residence_id" value="${this.residence_id == '0' ? '' : this.residence_id} ">
                <input type="hidden" name="residence_weeks" value="${this.residence_weeks}">
                <input type="hidden" name="airport_id" value="${this.airport_id == '0' ? '' : this.airport_id}">
                <input type="hidden" name="custom_airport[description]" value="${this.airport_id == 'custom_airport' ? this.custom_airport.description : ''}">
                <input type="hidden" name="custom_airport[price]" value="${this.airport_id == 'custom_airport' ? this.custom_airport.price : ''}">
                ${this.safeDataObj.visa != 0 ? `<input type="hidden" name="visa_checker" value="${this.visa_checker}">` : ''}
            `;
        },

        // API methods with enhanced error handling
        async get_course_price_info() {
            if (!this.course_price_info_url) return;

            this.isLoading = true;

            try {
                const response = await axios.get(this.course_price_info_url, {
                    params: {
                        course_id: this.course_id,
                        institute_id: this.institute_id,
                        start_date: this.formatDate(this.start_date),
                        course_weeks: this.course_weeks,
                        residence_id: this.residence_id,
                        custom_residence: this.residence_id == 'custom_residence' ? this.custom_residence : '',
                        residence_weeks: this.residence_weeks,
                        airport_id: this.airport_id,
                        custom_airport: this.airport_id == 'custom_airport' ? this.custom_airport : '',
                        insurance_checker: this.insurance_checker,
                        visa_checker: this.visa_checker,
                        currency_code: this.currency_code,
                        lang: this.lang,
                        coupon_code: this.coupon_status == 'true' ? this.coupon_code : '',
                    },
                });

                // Vue 3 Enhanced Reactivity: Direct assignment
                this.data_obj = {
                    ...this.data_obj,
                    ...response.data,
                    residences: response.data.residences || [],
                    airports: response.data.airports || [],
                    course: {
                        ...this.data_obj.course,
                        ...response.data.course,
                        discount_obj: {
                            discounts: {},
                            coupon: {},
                            ...response.data.course?.discount_obj
                        }
                    }
                };

            } catch (error) {
                console.error('Error fetching course price info:', error);
            } finally {
                this.isLoading = false;
            }
        },

        async get_employee_discount() {
            if (!this.get_employee_discount_url) return;

            try {
                const response = await axios.get(this.get_employee_discount_url);

                if (response.data.discount_type) {
                    this.employee_dsicount = response.data.discount;
                    this.employee_discount_type = response.data.discount_type;
                }
            } catch (error) {
                console.error('Error fetching employee discount:', error);
            }
        },

        async get_user_details() {
            if (!this.base_url) return;

            try {
                const response = await axios.get(this.base_url + '/get-user-details');
                this.user_details = response.data.user || {};
            } catch (error) {
                console.error('Error fetching user details:', error);
                this.user_details = {};
            }
        },

        async getResidences() {

            try {
                const response = await axios.get(this.base_url + '/api/get-residences', {
                    params: {
                        institute_id: this.institute_id,
                        residence_weeks: 1,
                        start_date: this.formatDate(this.start_date),
                        lang: this.lang,
                    },
                });

                this.residencesObj = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                console.error('Error fetching residences:', error);
                if (error.response?.status === 429) {
                    console.warn('Rate limit exceeded for residences. Retrying in 2 seconds...');
                    setTimeout(() => {
                        this.getResidences();
                    }, 2000);
                }
            }
        },

        async getAirports() {
            if (!this.base_url) return;

            try {
                const response = await axios.get(this.base_url + '/api/get-airports', {
                    params: {
                        institute_id: this.institute_id,
                        pref_currency: this.pref_currency,
                        lang: this.lang,
                    },
                });

                this.airportsObj = response.data;
            } catch (error) {
                console.error('Error fetching airports:', error);
            }
        },

        async getInstituteVacation() {
            if (!this.institute_id || !this.base_url) return;

            try {
                const response = await axios.get(this.base_url + '/api/get-institute-vacation', {
                    params: {
                        institute_id: this.institute_id,
                        lang: this.lang,
                    },
                });

                this.institute_vacations = response.data;
                this.generateDisabledVacationDates();
            } catch (error) {
                console.error('Error fetching vacation:', error);
            }
        },

        // Business logic methods
        change_employee_discount_type() {
            if (this.employee_discount_type == "percentage") {
                if (this.employee_dsicount > 100) {
                    this.employee_dsicount = 0;
                }
            }
        },

        choosingCustomResidence() {
            $('#residences-modal').modal('hide');
            this.residence_id = 'custom_residence';
            this.get_course_price_info();
        },

        choosingCustomAirport() {
            this.airport_id = 'custom_airport';
            this.get_course_price_info();
        },

        async institute_vacation_checker() {
            if (!this.institute_vacation_checker_url) return;

            try {
                const response = await axios.get(this.institute_vacation_checker_url, {
                    params: {
                        institute_id: this.institute_id,
                        date: this.formatDate(this.start_date),
                        weeks: this.course_weeks,
                        lang: this.lang,
                    },
                });

                this.vacation = response.data;

                if (this.vacation != '' && this.vacation.weeks > 0) {
                    $('#institute_vacation_checker_modal').modal('show');
                }
            } catch (error) {
                console.error('Error checking institute vacation:', error);
            }
        },

        async apply_coupon() {
            if (!this.coupon_code) {
                this.showAlert(this.tra?.enter_discount_code || 'برجاء ادخال كوبون الخصم', "error");
                return;
            }

            if (!this.check_coupon_url) return;

            try {
                const response = await axios.get(this.check_coupon_url, {
                    params: { coupon_code: this.coupon_code },
                });

                const data = response.data;
                if (data.status == "error") {
                    this.showAlert(data.status_msg, "error");
                } else {
                    this.coupon_status = 'true';
                    await this.get_course_price_info();
                    this.showAlert("تم تطبيق كود الخصم بنجاح", "success");
                }
            } catch (error) {
                console.error('Error applying coupon:', error);
                this.showAlert('حدث خطأ في تطبيق كود الخصم', "error");
            }
        },

        async remove_coupon() {
            this.coupon_status = '';
            this.coupon_code = '';
            await this.get_course_price_info();
            this.showAlert("تم حذف كود الخصم ", "error");
        },

        // Utility methods
        checkEmployeeDiscount() {
            if (this.user_details?.roles && this.user_details?.permissions &&
                (this.user_details.roles.includes('admin') || this.user_details.permissions.includes('employee-discount-create'))) {
                return true;
            }
            return false;
        },

        generateDisabledVacationDates() {
            this.disabledVacationDates = [];
            if (this.institute_vacations && Array.isArray(this.institute_vacations)) {
                this.institute_vacations.forEach(institute_vacations => {
                    const fromDate = new Date(institute_vacations.from_date);
                    const toDate = new Date(institute_vacations.to_date);

                    if (fromDate instanceof Date && toDate instanceof Date && !isNaN(fromDate) && !isNaN(toDate)) {
                        for (let date = new Date(fromDate); date <= toDate; date.setDate(date.getDate() + 1)) {
                            this.disabledVacationDates.push(new Date(date));
                        }
                    }
                });
            }
        },

        hide_vacation_modal() {
            $('#institute_vacation_checker_modal').modal('hide');
        },

        add_vacation_weeks() {
            if (this.vacation?.weeks) {
                this.residence_weeks += this.vacation.weeks;
            }
            $('#institute_vacation_checker_modal').modal('hide');
            this.vacationModal = false;
        },

        ResidencesChangeHandeler() {
            if (this.firstTimeChangeResWeeks) {
                this.residence_weeks = this.course_weeks;
                this.firstTimeChangeResWeeks = false;
            }
        },

        AllCoursesPopUpVraibalesAdding() {
            const vueInstance = this;

            $('.related-courses').each(function () {
                const anchor = $(this).find('a');
                if (anchor.length === 0) return;

                let href = anchor.attr('href');
                if (!href) href = '';

                if (href.includes('?')) {
                    href = href.split('?')[0];
                }

                const newParams = new URLSearchParams({
                    course_id: vueInstance.course_id,
                    institute_id: vueInstance.institute_id,
                    start_date: vueInstance.start_date,
                    course_weeks: vueInstance.course_weeks,
                    residence_id: vueInstance.residence_id,
                    custom_residence: vueInstance.residence_id == 'custom_residence' ? JSON.stringify(vueInstance.custom_residence) : '',
                    residence_weeks: vueInstance.residence_weeks,
                    airport_id: vueInstance.airport_id,
                    custom_airport: vueInstance.airport_id == 'custom_airport' ? JSON.stringify(vueInstance.custom_airport) : '',
                    insurance_checker: vueInstance.insurance_checker,
                    visa_checker: vueInstance.visa_checker,
                    coupon_code: vueInstance.coupon_status == 'true' ? vueInstance.coupon_code : '',
                });

                const updatedHref = `${href}?${newParams.toString()}`;
                anchor.attr('href', updatedHref);
            });
        },

        change_to_get_requests() {
            let queryString = window.location.search;
            let savedParams = new URLSearchParams(queryString);

            let course_weeks = +savedParams.get('course_weeks');
            let start_date = savedParams.get('start_date');
            let insurance_checker = +savedParams.get('insurance_checker');
            let residence_id = +savedParams.get('residence_id');
            let residence_weeks = savedParams.get('residence_weeks');
            let airport_id = +savedParams.get('airport_id');
            let visa_checker = savedParams.get('visa_checker');
            this.request_id = savedParams.get('request_id');

            if (this.old && Object.keys(this.old).length !== 0) {
                course_weeks = this.old.course_weeks || course_weeks;
                start_date = this.old.start_date || start_date;
                residence_id = this.old.residence_id !== undefined ? this.old.residence_id : residence_id;
                residence_weeks = this.old.residence_weeks || residence_weeks;
                airport_id = this.old.airport_id !== undefined ? this.old.airport_id : airport_id;
                visa_checker = this.old.visa_checker !== undefined ? this.old.visa_checker : visa_checker;
                this.insurance_checker = this.old.insurance_checker !== undefined ? this.old.insurance_checker : this.insurance_checker;
                if (this.old.custom_airport?.description) {
                    this.custom_airport.description = this.old.custom_airport.description;
                }
                if (this.old.custom_airport?.price) {
                    this.custom_airport.price = this.old.custom_airport.price;
                }
            }

            if (course_weeks) { this.course_weeks = course_weeks; }
            if (start_date !== undefined && start_date !== null) { this.start_date = new Date(start_date); }
            if (residence_id !== undefined && residence_id !== null) { this.residence_id = residence_id; }
            if (residence_weeks !== undefined && residence_weeks !== null) { this.residence_weeks = residence_weeks; }
            if (insurance_checker !== undefined && insurance_checker !== null) { this.insurance_checker = insurance_checker; }
            if (airport_id !== undefined && airport_id !== null) { this.airport_id = airport_id; }

            if (this.app_name != 'sat-edu') {
                this.visa_checker = '0';
            }
            else if (visa_checker == 'null' || this.app_name != 'sat-edu') {
                this.visa_checker = '0';
            } else if (visa_checker == undefined) {
                this.visa_checker = '';
            } else {
                this.visa_checker = visa_checker;
            }
        },

        goToRelatedCourse() {
            const relatedCoursesElement = $("#related-courses");
            if (relatedCoursesElement.length) {
                $('html, body').animate({
                    scrollTop: relatedCoursesElement.offset().top - 100
                }, 500);
            }
        },

        invoice(data = null) {
            this.compare_offer = false;
            if (data?.['WASendOffer']) {
                $('.WASendOffer').attr('name', 'WASendOffer').val(1);
            }
            $('.invoice_checker').attr('name', 'invoice').val(1);
            $('.course-prices-form').attr('target', '_blank');
            setTimeout(function () {
                $('.invoice_checker').removeAttr('name');
                $('.WASendOffer').removeAttr('name');
                $('.course-prices-form').removeAttr('target');
            }, 1000);
        },

        pay_with_tamara() {
            if (!this.isTamaraEnabled) {
                return;
            }
            this.tamara_errors = { name: '', email: '', phone: '' };
            this.load_tamara_customer();

            if (this.safeDataObj.course && !this.safeDataObj.course.price_orgi) {
                this.showAlert(this.tra?.course_not_available || 'الدورة غير متاحة تحت عدد الاسابيع المختارة', 'error');
                return;
            }

            this.init_tamara_phone_input();
            $('#tamara-customer-modal').modal('show');
        },

        init_tamara_phone_input() {
            if (this.tamara_iti || !window.intlTelInput) {
                return;
            }
            const input = document.getElementById('tamara-phone');
            if (!input) {
                return;
            }
            this.tamara_iti = window.intlTelInput(input, {
                formatOnDisplay: false,
                initialCountry: this.tamara_customer.country_iso || 'sa',
                preferredCountries: ['sa'],
                utilsScript: (this.base_url || '') + '/website/vendor/intl-tel-input/js/utils.js',
            });
        },

        get_tamara_dial_code() {
            if (this.tamara_iti) {
                const country = this.tamara_iti.getSelectedCountryData();
                if (country && country.dialCode) {
                    this.tamara_customer.dial_code = country.dialCode;
                    this.tamara_customer.country_iso = country.iso2 || this.tamara_customer.country_iso;
                }
            }
            return this.tamara_customer.dial_code || '966';
        },

        load_tamara_customer() {
            let saved = null;
            try {
                saved = JSON.parse(localStorage.getItem('nl_tamara_customer') || 'null');
            } catch (e) {
                saved = null;
            }

            if (saved && typeof saved === 'object') {
                this.tamara_customer.name = saved.name || this.tamara_customer.name || '';
                this.tamara_customer.email = saved.email || this.tamara_customer.email || '';
                this.tamara_customer.phone = saved.phone || this.tamara_customer.phone || '';
                this.tamara_customer.dial_code = saved.dial_code || this.tamara_customer.dial_code || '966';
                this.tamara_customer.country_iso = saved.country_iso || this.tamara_customer.country_iso || 'sa';
            }

            if (this.auth_student && typeof this.auth_student === 'object') {
                this.tamara_customer.name = this.tamara_customer.name || this.auth_student.name || '';
                this.tamara_customer.email = this.tamara_customer.email || this.auth_student.email || '';
                this.tamara_customer.phone = this.tamara_customer.phone || this.auth_student.phone || '';
            }
        },

        save_tamara_customer() {
            try {
                localStorage.setItem('nl_tamara_customer', JSON.stringify({
                    name: this.tamara_customer.name || '',
                    email: this.tamara_customer.email || '',
                    phone: this.tamara_customer.phone || '',
                    dial_code: this.tamara_customer.dial_code || '966',
                    country_iso: this.tamara_customer.country_iso || 'sa',
                }));
            } catch (e) {
                // ignore storage errors
            }
        },

        validate_tamara_customer() {
            this.tamara_errors = { name: '', email: '', phone: '' };
            let valid = true;

            if (!this.tamara_customer.name || !this.tamara_customer.name.trim()) {
                this.tamara_errors.name = this.tra?.full_name_required || 'الاسم مطلوب';
                valid = false;
            }

            if (!this.tamara_customer.email || !this.tamara_customer.email.trim()) {
                this.tamara_errors.email = this.tra?.email_required || 'البريد الإلكتروني مطلوب';
                valid = false;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.tamara_customer.email)) {
                this.tamara_errors.email = this.tra?.invalid_email || 'برجاء ادخال بريد إلكتروني صحيح';
                valid = false;
            }

            if (!this.tamara_customer.phone || !this.tamara_customer.phone.trim()) {
                this.tamara_errors.phone = this.tra?.phone_required || 'رقم الجوال مطلوب';
                valid = false;
            } else {
                const cleanPhone = this.tamara_customer.phone.replace(/\D/g, '');
                if (cleanPhone.length < 9) {
                    this.tamara_errors.phone = this.tra?.invalid_phone || 'رقم الجوال غير صحيح';
                    valid = false;
                }
            }

            return valid;
        },

        proceed_to_tamara() {
            if (!this.validate_tamara_customer()) {
                return;
            }

            const dial_code = this.get_tamara_dial_code();
            this.save_tamara_customer();
            this.compare_offer = false;

            $('.tamara_checkout_flag').attr('name', 'tamara_checkout').val(1);
            $('.tamara_name_field').attr('name', 'tamara_name').val(this.tamara_customer.name);
            $('.tamara_email_field').attr('name', 'tamara_email').val(this.tamara_customer.email);
            $('.tamara_phone_field').attr('name', 'tamara_phone').val(this.tamara_customer.phone);
            $('.tamara_dial_code_field').attr('name', 'tamara_dial_code').val(dial_code);

            $('.invoice_checker').removeAttr('name');
            $('.WASendOffer').removeAttr('name');

            $('#tamara-customer-modal').modal('hide');

            setTimeout(function () {
                $('#course-prices-form').submit();
                setTimeout(function () {
                    $('.tamara_checkout_flag').removeAttr('name').val(0);
                    $('.tamara_name_field').removeAttr('name').val('');
                    $('.tamara_email_field').removeAttr('name').val('');
                    $('.tamara_phone_field').removeAttr('name').val('');
                    $('.tamara_dial_code_field').removeAttr('name').val('');
                }, 1000);
            }, 300);
        },

        save_new_student_offer() {
            if (this.add_new_student_request_obj?.['student_id']) {
                $('.save_new_student_offer').attr('name', 'student_id').val(this.add_new_student_request_obj['student_id']);
            }
        },

        sub_form_with_request_id() {
            $('input[name="request_id"]').val(this.request_id);
            $('#course-prices-form').submit();
        },

        ageRangeDisplay(residence) {
            if (!residence) return this.tra.not_specified || 'غير محدد';

            const { min_age, max_age } = residence;

            if (min_age == null && max_age == null) {
                return this.tra.not_specified || 'غير محدد';
            }
            if (min_age != null && max_age == null) {
                return `${this.tra.more_than || 'أكثر من'} ${min_age}`;
            }
            if (min_age == null && max_age != null) {
                return `${this.tra.less_than || 'أقل من'} ${max_age}`;
            }
            if (min_age == max_age) {
                return `${max_age}`;
            }
            return `${this.tra.from || 'من'} ${min_age} ${this.tra.to || 'إلى'} ${max_age}`;
        },
    },
    watch: {
        // Enhanced watchers with better reactivity handling
        data_obj: {
            deep: true
        },

        course_weeks() {
            this.get_course_price_info();
            this.institute_vacation_checker();
            this.AllCoursesPopUpVraibalesAdding();
            if (this.residence_id) {
                this.residence_weeks = this.course_weeks;
            }
        },
        residence_weeks() {
            this.get_course_price_info();
            this.AllCoursesPopUpVraibalesAdding();
        },
        start_date() {
            this.get_course_price_info();
            this.AllCoursesPopUpVraibalesAdding();
            this.institute_vacation_checker();
        },
        residence_id() {
            this.get_course_price_info();
            if (this.residence_id != 0 && this.residence_id != 'custom_residence') {
                $('#residences-modal').modal('hide');
            }

            if (this.start_date != '') {
                this.institute_vacation_checker();
            }
            this.AllCoursesPopUpVraibalesAdding();
        },
        airport_id() {
            this.get_course_price_info();
            this.AllCoursesPopUpVraibalesAdding();
            if (this.airport_id != 0 && this.airport_id != 'custom_airport') {
                // Reset custom_airport when selecting a regular airport
                this.custom_airport.description = '';
                this.custom_airport.price = '';
            }
        },
        visa_checker() {
            this.get_course_price_info();
            this.AllCoursesPopUpVraibalesAdding();
        },
        insurance_checker() {
            this.get_course_price_info();
            this.AllCoursesPopUpVraibalesAdding();
        },
        currency_code() {
            this.get_course_price_info();
            this.AllCoursesPopUpVraibalesAdding();
        }
    },
    async beforeMount() {
        // Ensure Swal is globally available (webpack UMD may not set window.Swal)
        if (typeof window.Swal === 'undefined' && typeof window.Sweetalert2 !== 'undefined') {
            window.Swal = window.Sweetalert2;
        }

        // Initialize data from URL parameters and old values
        this.change_to_get_requests();

        // Pre-fill Tamara customer details: localStorage -> logged-in student
        this.load_tamara_customer();

        // Fetch initial data
        await Promise.all([
            this.get_course_price_info(),
            this.get_employee_discount(),
            this.get_user_details(),
            this.getResidences(),
            this.getInstituteVacation(),
            this.getAirports()
        ]);

        // Handle post errors modal
        window.setTimeout(() => {
            if (this.post_errors?.name || this.post_errors?.email) {
                $('#save-offer-file').modal('show');
            }

            // Surface Tamara payment / validation errors
            if (this.post_errors?.payment_error) {
                const msg = Array.isArray(this.post_errors.payment_error)
                    ? this.post_errors.payment_error[0]
                    : this.post_errors.payment_error;
                this.showAlert(msg, 'error');
            }

            // If Tamara customer validation failed, reopen the modal with errors
            if (this.isTamaraEnabled && (this.post_errors?.tamara_name || this.post_errors?.tamara_email || this.post_errors?.tamara_phone)) {
                this.tamara_errors = {
                    name: this.post_errors?.tamara_name ? (Array.isArray(this.post_errors.tamara_name) ? this.post_errors.tamara_name[0] : this.post_errors.tamara_name) : '',
                    email: this.post_errors?.tamara_email ? (Array.isArray(this.post_errors.tamara_email) ? this.post_errors.tamara_email[0] : this.post_errors.tamara_email) : '',
                    phone: this.post_errors?.tamara_phone ? (Array.isArray(this.post_errors.tamara_phone) ? this.post_errors.tamara_phone[0] : this.post_errors.tamara_phone) : '',
                };
                this.init_tamara_phone_input();
                $('#tamara-customer-modal').modal('show');
            }
        }, 800);
    },
};
</script>

<style scoped>
.p-datepicker.p-inputwrapper-filled {
    width: 100% !important;
}

.booking-form-container {
    position: relative;
}

/* Price display enhancements */
.total-price-section,
.langtour-total-section {
    margin-bottom: 0.5rem;
}

.total-price-display {
    transition: all 0.3s ease;
}

.price-value {
    font-weight: bold;
}

.currency-code {
    margin-left: 0.25rem;
}

/* Course details section */
.course-details-section {
    margin-bottom: 1rem;
}

.course-name-container {
    margin-bottom: 0.5rem;
}

.course-name {
    font-weight: 500;
    line-height: 1.4;
}

.course-pricing {
    align-items: center;
    flex-wrap: wrap;
}

.price-info {
    margin: 0;
    margin-right: 0.5rem;
}

.price-amount {
    font-weight: bold;
}

.price-separator {
    color: #666;
    font-weight: bold;
}

.weeks-display {
    white-space: nowrap;
}

.discounted-price {
    color: #28a745 !important;
}

/* Discount badges */
.discount-badges {
    position: relative;
}

/* Form sections */
.start-date-container {
    margin-bottom: 1rem;
}

.residence-box {
    margin-bottom: 1rem;
}

.residence-price,
.airport-price {
    font-weight: 500;
}

.residence-description {
    line-height: 1.4;
}

.availability-dates {
    font-size: 0.9em;
    line-height: 1.3;
}

.weeks-info {
    white-space: nowrap;
}

/* Additional fees section */
.fee-item {
    margin-bottom: 0.5rem;
}

.additional-fee-item {
    margin-bottom: 0.75rem;
}

/* Coupon section */
.coupon-input-section {
    margin-top: 1rem;
}

/* Action buttons */
.action-buttons-section {
    margin-top: 1.5rem;
}

.whatsapp-notice {
    font-size: 0.9em;
    line-height: 1.4;
}

.admin-buttons {
    margin-top: 1rem;
}

/* Loading states */
.booking-form-container.loading .total-price-display {
    opacity: 0.6;
}

.booking-form-container.loading .price-value {
    animation: pulse 1.5s ease-in-out infinite;
}

/* Animations */
@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

@keyframes priceUpdate {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }

    100% {
        transform: scale(1);
    }
}

.price-value.updating {
    animation: priceUpdate 0.3s ease-in-out;
}

/* Responsive design */
@media (max-width: 768px) {
    .course-pricing {
        flex-direction: column;
        align-items: flex-start;
    }

    .price-separator {
        display: none;
    }

    .weeks-display {
        margin-top: 0.25rem;
    }

    .total-price-display {
        font-size: 1.1em;
    }
}

/* Accessibility */
.price-value:focus,
.total-price-display:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
}

/* Error states */
.is-invalid {
    border-color: #dc3545;
}

.text-danger {
    color: #dc3545 !important;
}

/* Success states */
.text-success {
    color: #28a745 !important;
}

/* Form controls enhancement */
.form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Button enhancements */
.btn {
    transition: all 0.2s ease-in-out;
}

.btn:hover {
    transform: translateY(-1px);
}

.btn:active {
    transform: translateY(0);
}

/* Tamara Payment Button */
.tamara-pay-btn {
    background: linear-gradient(135deg, #0f1b2d 0%, #1a2b4a 100%);
    border: none;
    font-weight: 600;
    gap: 8px; 
}

.tamara-pay-btn:hover {
    background: linear-gradient(135deg, #1a2b4a 0%, #243b6b 100%);
}

.tamara-btn-logo {
    height: 22px;
    width: auto;
}

.tamara-modal-logo {
    height: 32px;
    width: auto;
}

/* Modal enhancements */
.modal-content {
    border-radius: 10px;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* Loading spinner */
.price-info-loader-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    display: none;
}

.booking-form-container.loading .price-info-loader-box {
    display: block;
}

.price-info-loader {
    width: 30px;
    height: 30px;
}
</style>